import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "overflow-hidden rounded-2xl font-poppins" }
const _hoisted_2 = {
  role: "list",
  class: "divide-y divide-gray-200 list-none"
}
const _hoisted_3 = { class: "block" }
const _hoisted_4 = { class: "flex items-center" }
const _hoisted_5 = { class: "min-w-0 flex-1 sm:flex sm:items-center sm:justify-between" }
const _hoisted_6 = { class: "truncate" }
const _hoisted_7 = { class: "flex text-sm items-center" }
const _hoisted_8 = { class: "font-poppins text-lg ml-1 text-black py-0 my-0" }

import { computed } from 'vue';
import { CheckIcon } from '@heroicons/vue/outline';
import { Promotion } from '@uniti-internet/promotions-js-client/dist/utilities/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'PromotionDiscounts',
  props: {
    suggestedPromotion: {}
  },
  setup(__props: any) {

const props = __props;

const actions = computed(() => {
  return props.suggestedPromotion.actions.filter((action) => {
    return action.discountDescription !== '';
  });
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(actions.value, (action) => {
        return (_openBlock(), _createElementBlock("li", {
          key: action.name
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(CheckIcon), {
                      class: "flex-shrink-0 w-6 h-6 text-brand-secondary-accent",
                      "aria-hidden": "true"
                    }),
                    _createElementVNode("p", _hoisted_8, _toDisplayString(action.discountDescription), 1)
                  ])
                ]),
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mt-1 flex-shrink-0" }, [
                  _createElementVNode("div", { class: "flex overflow-hidden -space-x-1" })
                ], -1))
              ])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})